import { ProductConfig } from "@core/interface/environment.interface";
import { ProductEnum } from "../product.enum";

export const PzpEnvironment: ProductConfig = {
    baseUrl: "",
    schemaEndpoint: "./api/v1/pzp-report",
    productUrl: ProductEnum.PZP,
    maxSingleFileSizeUpload: null,
    maxBulkFilesSizeUpload: 50000000,
    deployUrl: ProductEnum.PZP + '/',
    skipSteps: [
        {
            skipStepName: 'damage-extent',
            conditions: [
                {
                    stepName: 'incident-causer',
                    param: 'incidentCauser',
                    values: ['1'],
                    or: {
                        skipStepName: 'damage-extent',
                        conditions: [
                            {
                                stepName: 'damaged-objects',
                                param: 'damagedObjects',
                                subParam: 'choices',
                                values: ['3'],
                                negotiate: true,
                                dependency:
                                {
                                    skipStepName: 'damage-extent',
                                    conditions: [{
                                        stepName: 'incidentCauser',
                                        param: 'incidentCauser',
                                        values: ['2'],
                                    }],
                                }
                            }
                        ]
                    }
                },
            ]
        },
        {
            skipStepName: 'payment',
            conditions: [
                {
                    stepName: 'incident-causer',
                    param: 'incidentCauser',
                    values: ['1'],
                    // or: {
                    //     skipStepName: 'payment',
                    //     conditions: [
                    //         {
                    //             stepName: 'incident-causer',
                    //             param: 'incidentCauser',
                    //             values: ['2'],
                    //         },
                    //         {
                    //             stepName: 'damaged-objects',
                    //             param: 'damagedObjects',
                    //             subParam: 'choices',
                    //             values: ['1'],
                    //         },
                    //     ]
                    // }
                },
            ]
        },
        {
            skipStepName: 'documents',
            conditions: [
                {
                    stepName: 'incident-causer',
                    param: 'incidentCauser',
                    values: ['1'],
                },
                {
                    stepName: 'damaged-objects',
                    param: 'damagedObjects',
                    subParam: 'choices',
                    values: ['1', '2'],
                },
            ]
        }
    ],
};
